import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Single Social Club";
const BASE = "https://singlesocialclub.app";

// Per-page SEO: unique title, description, and canonical so each public
// page shows its own snippet in Google results.
export default function Seo({ title, description, path = "/", noindex = false }) {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Meet Verified Singles Through Real-World Group Outings`;
    const url = `${BASE}${path}`;
    return (
        <Helmet prioritizeSeoTags>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={url} />
            <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={url} />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
        </Helmet>
    );
}
